module.exports = __webpack_public_path__ + "static/giantTrophy-cdfca671c26a28d15b19f8646556c531.jpg";